module.exports = __webpack_public_path__ + "img/arrow.23051948.svg";